import type { DistanceUnit } from './types';

export const distanceUnitLabel: Record<DistanceUnit, string> = {
	METER: 'm',
	KILOMETER: 'km',
	FOOT: 'ft',
	MILE: 'mi',
};
